// ORDER IS IMPORTANT. PLEASE DON'T MESSUP
const STEP_1 = 0
const STEP_2 = 1

/*
 * campaign stat structure:
 * label       : Table label
 * def         : Definition of stat
 * only        : Only show for Step1 or Step2
 * graphHidden : Should be shown on graph
 */
let campaignStatProps = {
  date: {
    label  : 'Step ',
    def    : '',
    graphHidden: true
  },
  hits: {
    label  : 'Clicks',
    def    : 'Unique Redirects'
  },
  partials: {
    label  : 'Partials',
    def    : 'Landing Page Submissions'
  },
  partial_percent: {
    label  : 'Partial %',
    def    : 'Partials / Clicks',
    legend : [{value: 0.001, style: 'white'},
              {value: 20   , style: 'yellow'},
              {value: 9999 , style: 'white'}]
  },
  sales: {
    label  : 'Sales',
    def    : 'Tracking Pixel Conversions'
  },
  partial_to_sales_percent: {
    label  : 'Partial To Sales %',
    def    : 'Sales / Partials'
  },
  overage_percent: {
    label  : 'Breakage %',
    def    : 'Overage'
  },
  conversion_percent: {
    label  : 'Conversion %',
    def    : 'Sales / Clicks',
    only   : STEP_1
  },
  take_rate_percent: {
    label  : 'Take Rate %',
    def    : 'Upsell Conversions',
    only   : STEP_2,
    legend : [{value: 0.001, style: 'white'},
              {value: 49.99, style: 'red'},
              {value: 59.99, style: 'orange'},
              {value: 69.99, style: 'yellow'},
              {value: 79.99, style: 'white'},
              {value: 99999, style: 'green'}]
  },
  attempt_percent: {
    label  : 'Attempt %',
    def    : '(Sales + Declines) / Partials'
  },
  declines: {
    label  : 'Declines',
    def    : 'Gross Decline Transactions'
  },
  decline_percent: {
    label  : 'Decline %',
    def    : 'Declines / (Declines + Sales)',
    legend : [{value: 0.001, style: 'white'},
              {value: 10   , style: 'green'},
              {value: 14.99, style: 'yellow'},
              {value: 19.99, style: 'orange'},
              {value: 9999 , style: 'red'}]
  },
  epc: {
    label : 'BEPC',
    def   : 'Blended Earnings Per Click',
    only   : STEP_1,
    graphHidden: true
  }
}

export {campaignStatProps}



// WEBPACK FOOTER //
// ./src/components/campaign-stat-props.js